import t from '~/scopes/campaign/data/metals/potassium.translations'
import SECTIONS from '~/scopes/campaign/data/metals/sections.translations'

export default {
  name: t.name,
  smartphone: {
    label: t.smartphoneLabel,
  },
  whatItDoes: {
    text: t.whatItDoesText,
    sourceRefs: ['ademe2024', 'scrreenPotash2025'],
  },
  extraction: [
    {
      text: t.extractionText1,
      sourceRefs: ['usgsMcs2025', 'scrreenPotash2025'],
    },
  ],
  quickFact: {
    text: t.quickFactText,
    sourceRefs: ['scrreenPotash2025'],
  },
  // Climate reads `n/a`, and so does every human sub-section — the sheet leaves
  // that whole read-more empty and gives only the summary.
  impacts: {
    environmental: {
      summary: {
        text: t.envSummaryText,
        sourceRefs: ['scrreenPotash2025'],
      },
      blocks: [
        {
          title: SECTIONS.environmentalWater,
          text: t.envWaterText,
          sourceRefs: ['scrreenPotash2025'],
        },
        {
          title: SECTIONS.environmentalSoil,
          text: t.envSoilText,
          sourceRefs: ['pblEnvironmental2024', 'scrreenPotash2025'],
        },
        {
          title: SECTIONS.environmentalBiodiversity,
          text: t.envBiodiversityText,
          sourceRefs: ['pblEnvironmental2024', 'scrreenPotash2025'],
        },
      ],
    },
    human: {
      summary: {
        text: t.humanSummaryText,
        sourceRefs: ['pblEnvironmental2024', 'scrreenPotash2025'],
      },
      blocks: [],
    },
    geopolitical: {
      summary: {
        text: t.geoSummaryText,
        sourceRefs: ['usgsMcs2025', 'scrreenPotash2025'],
      },
      blocks: [
        {
          title: SECTIONS.geopoliticalDug,
          text: t.geoDugText,
          sourceRefs: ['usgsMcs2025'],
        },
        {
          title: SECTIONS.geopoliticalProcessed,
          text: t.geoProcessedText,
          sourceRefs: ['usgsMcs2025', 'scrreenPotash2025'],
        },
        {
          title: SECTIONS.geopoliticalLeverage,
          text: t.geoLeverageText,
          sourceRefs: ['scrreenPotash2025'],
        },
      ],
    },
  },
  supplyRisk: {
    summary: {
      text: t.supplySummaryText,
      sourceRefs: ['scrreenPotash2025'],
    },
    blocks: [
      {
        title: SECTIONS.supplyRiskReserves,
        text: t.supplyReservesText,
        sourceRefs: ['usgsMcs2025'],
      },
      {
        title: SECTIONS.supplyRiskDemand,
        text: t.supplyDemandText,
        sourceRefs: ['scrreenPotash2025'],
      },
    ],
  },
  recycling: {
    summary: {
      text: t.recyclingSummaryText,
      sourceRefs: ['jrcCircular2017', 'scrreenPotash2025'],
    },
    blocks: [
      {
        title: SECTIONS.recyclingOutlook,
        text: t.recyclingOutlookText,
        sourceRefs: ['jrcCircular2017', 'scrreenPotash2025'],
      },
    ],
  },
  // `*` on the four scores it names, environmental included even
  // though it reads "Not assessed"; the sheet gives no second note.
  footnotes: [
    {
      body: [
        {
          text: t.footnote1Text1,
          sourceRefs: ['ademe2024'],
        },
      ],
      slots: [
        'environmentalScore',
        'humanScore',
        'geopoliticalScore',
        'supplyRiskScore',
      ],
    },
  ],
  mine0Region: t.mine0Region,
  mine1Region: t.mine1Region,
  mine2Region: t.mine2Region,
  mine3Region: t.mine3Region,
  mine4Region: t.mine4Region,
} as const
